import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SecurityService } from '@services/security.service';

@Directive({ selector: '[appIsAuthorizedForManagingCompany]' })
export class IsAuthorizedForManagingCompanyDirective implements OnInit, OnDestroy {
  @Input('appIsAuthorizedForManagingCompany') public userManagingCompanyAuthority: string | string[];

  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private readonly securityService: SecurityService,
    private readonly renderer: Renderer2,
    private readonly el: ElementRef
  ) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnInit(): void {
    const authorization$ = Array.isArray(this.userManagingCompanyAuthority)
      ? this.securityService.isAuthorizedForAnyManagingCompany(this.userManagingCompanyAuthority)
      : this.securityService.isAuthorizedForManagingCompany(this.userManagingCompanyAuthority);

    authorization$.pipe(takeUntil(this.onDestroy$)).subscribe((hasAuthority) => {
      if (!hasAuthority) {
        this.removeElement();
      }
    });
  }

  private removeElement(): void {
    const parent = this.renderer.parentNode(this.el.nativeElement);
    this.renderer.removeChild(parent, this.el.nativeElement);
  }
}
